import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import { getVarsomeHost } from "../../../../state/selectors/general.selectors";
import withErrorGuard from "../../../../HOC/withErrorGuard";
import ComponentPanel from "../../../../components/atoms/ComponentPanel/ComponentPanel";
import { getLovdData } from "../../../../state/selectors/Lovd.selectors";
import PathogenicitiesTable from "./components/PathogenicitiesTable";
import IndividualsTable from "./components/IndividualsTable";
import HelperText from "../../../../components/atoms/HelperText";

const Lovd = (props) => {
  const { lovdData, varsomeHost } = props;

  if (!lovdData || (lovdData && lovdData.length === 0)) return null;

  const tmpl = lovdData?.map((item, index) => {
    const { version } = item;
    return (
      <div
        key={index}
        className="varsome-result-fixed"
        data-testid="lovd-component"
      >
        <div className="varsome-container varsome-container__basic">
          <ComponentPanel
            title={
              <>
                <a href={getVarsoUrl("https://www.lovd.nl/")} target="_blank">
                  LOVD
                </a>
                <HelperText fieldDescriptionKey="LOVD" />
              </>
            }
            version={version}
            content={
              <>
                <IndividualsTable
                  individuals={item?.individuals}
                  varsomeHost={varsomeHost}
                />
                <PathogenicitiesTable pathogenicities={item?.pathogenicities} />
              </>
            }
          />
        </div>
      </div>
    );
  });

  return tmpl;
};

Lovd.propTypes = {
  lovdData: PropTypes.arrayOf(
    PropTypes.shape({
      version: PropTypes.string,
      genes: PropTypes.arrayOf(
        PropTypes.shape({
          gene_id: PropTypes.number,
          hgnc_id: PropTypes.number,
          gene_symbol: PropTypes.string,
        })
      ),
      individuals: PropTypes.arrayOf(
        PropTypes.shape({
          comments: PropTypes.arrayOf(PropTypes.string),
          gender: PropTypes.string,
          phenotypes: PropTypes.arrayOf(PropTypes.string),
          pub_med_references: PropTypes.arrayOf(PropTypes.number),
          variants: PropTypes.arrayOf(
            PropTypes.shape({
              comments: PropTypes.arrayOf(PropTypes.string),
              is_current: PropTypes.bool,
              is_lifted_over: PropTypes.bool,
              lovd_link: PropTypes.string,
              pathogenicity: PropTypes.shape({
                clinical_classification_submitter: PropTypes.string,
                clinical_classification_curator: PropTypes.string,
                effect_submitter: PropTypes.string,
                effect_curator: PropTypes.string,
                effect_symbol: PropTypes.string,
              }),
              variant_info: PropTypes.arrayOf(
                PropTypes.shape({
                  variant_id: PropTypes.string,
                  variant_notation: PropTypes.string,
                })
              ),
            })
          ),
        })
      ),
      pathogenicities: PropTypes.arrayOf(
        PropTypes.shape({
          clinical_classification_submitter: PropTypes.string,
          clinical_classification_curator: PropTypes.string,
          effect_submitter: PropTypes.string,
          effect_curator: PropTypes.string,
          effect_symbol: PropTypes.string,
        })
      ),
    })
  ),
  varsomeHost: PropTypes.string,
};

Lovd.defaultProps = {
  lovdData: [],
  varsomeHost: null,
};

const mapStateToProps = (state) => ({
  lovdData: getLovdData(state),
  varsomeHost: getVarsomeHost(state),
});

export default connect(
  mapStateToProps,
  {}
)(withErrorGuard(Lovd, "LOVD", "LOVD"));
